"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoralisCoreProvider = void 0;
var Error_1 = require("./Error");
var MoralisCoreProvider = /** @class */ (function () {
    function MoralisCoreProvider() {
    }
    MoralisCoreProvider.getDefault = function () {
        if (!this.core) {
            throw new Error_1.MoralisCoreError({
                code: Error_1.CoreErrorCode.NOT_INITIALIZED,
                message: 'Default instance of MoralisCore is not set',
            });
        }
        return this.core;
    };
    MoralisCoreProvider.setDefault = function (core) {
        if (this.core) {
            throw new Error_1.MoralisCoreError({
                code: Error_1.CoreErrorCode.ALREADY_INITIALIZED,
                message: 'Default instance of MoralisCore is already set',
            });
        }
        this.core = core;
    };
    return MoralisCoreProvider;
}());
exports.MoralisCoreProvider = MoralisCoreProvider;
//# sourceMappingURL=MoralisCoreProvider.js.map